import React, { useState } from "react";
import { Helmet } from "react-helmet";
import classes from "./TechnicalOverview.module.scss";
import useWindowSize from "../hooks/useWindowSize";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import Intro from "../components/technicalOverviewComponents/Intro";
import Auth from "../components/technicalOverviewComponents/Auth";
import Depend from "../components/technicalOverviewComponents/Depend";
import Fetch from "../components/technicalOverviewComponents/Fetch";
import AddCustomer from "../components/technicalOverviewComponents/AddCustomer";

const TechnicalOverview = () => {
  const [openTab, setOpenTab] = useState("Intro");
  const { width } = useWindowSize();

  return (
    <>
      <Helmet>
        <title>Technical Overview | DDD Invoices</title>
      </Helmet>
      {width > 768 && (
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`}>
          <Intro openTab={openTab} setOpenTab={setOpenTab} />
          <Auth openTab={openTab} setOpenTab={setOpenTab} />
          <Fetch openTab={openTab} setOpenTab={setOpenTab} />
          <Depend openTab={openTab} setOpenTab={setOpenTab} />
          {/* <AddCustomer openTab={openTab} setOpenTab={setOpenTab} /> */}
        </div>
      )}
      {width <= 768 && <MobileVersion />}
    </>
  );
};

export default TechnicalOverview;
